import { render, staticRenderFns } from "./page-path.vue?vue&type=template&id=b899961a&scoped=true"
import script from "./page-path.vue?vue&type=script&lang=js"
export * from "./page-path.vue?vue&type=script&lang=js"
import style0 from "./page-path.vue?vue&type=style&index=0&id=b899961a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899961a",
  null
  
)

export default component.exports